import { ExclamationCircleOutlined } from '@ant-design/icons';
import { css } from '@emotion/react';
import styled from 'types/theme.types';
import type { ReactNode } from 'react';
import Tooltip from 'components/common/bridged-tooltip';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';

export const Warning: React.FC<{ content: ReactNode }> = ({ content }) => {
  return (
    <Tooltip title={content}>
      <StyledExclamationCircleOutlined />
    </Tooltip>
  );
};

const StyledExclamationCircleOutlined = styled(ExclamationCircleOutlined)`
  ${legacyOnly(
    theme => css`
      color: ${theme.warningYellowDarker};
    `
  )}
  ${newDesignOnly(css`
    color: var(--icon-warning);
  `)}
`;
